import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface InitState {
  isLoading: boolean;
}

const initialState: InitState = {
  isLoading: false
};

export const dataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    }
  }
});

export const { setIsLoading } = dataSlice.actions;

export default dataSlice.reducer;
